'use client';

import { useCallback } from 'react';

declare global {
  const FB: any;
  interface Window {
    fbAsyncInit: () => void;
  }
}

/**
 * Simplified Facebook SDK hook
 * Only provides logout functionality - login is handled via OAuth redirect
 */
export const useFacebookSDK = () => {
  const logoutFromFacebook = useCallback(() => {
    return new Promise<void>((resolve) => {
      if (typeof FB !== 'undefined') {
        try {
          // First check if user is logged in before attempting logout
          (FB as any).getLoginStatus((response: any) => {
            if (response.status === 'connected') {
              // User is logged in, proceed with logout
              const timeout = setTimeout(() => {
                resolve();
              }, 500);
              (FB as any).logout(() => {
                clearTimeout(timeout);
                resolve();
              });
            } else {
              // User is not logged in, no need to logout
              resolve();
            }
          });
        } catch (error) {
          console.warn('Facebook getLoginStatus failed:', error);
          resolve();
        }
      } else {
        resolve();
      }
    });
  }, []);

  return {
    logoutFromFacebook,
  };
};
